module.exports = __webpack_public_path__ + "img/zfr4.60ec4635.jpg";